import { Stack } from '@mui/material';
import { HeaderBreadcrumbs, ScreenWrap } from '../../components';
import { useParams } from 'react-router';
import ReflectionPointForm from './ReflectionPointForm';

export default function CreateReflectionPointScreen() {
  const { weekNumber, weekId } = useParams();

  return (
    <ScreenWrap>
      <Stack gap={3}>
        <HeaderBreadcrumbs
          title="Create Reflection Point"
          items={[
            {
              name: `Program Week ${weekNumber}`,
              url: `/program/${weekNumber}/${weekId}/reflection-points`,
            },
          ]}
        />
        <ReflectionPointForm existing={undefined} />
      </Stack>
    </ScreenWrap>
  );
}
